import React from 'react';

// tslint:disable-next-line:variable-name
const SelectPortalContext = React.createContext<React.RefObject<HTMLDivElement> | null>(null);

interface SelectPortalProps {
  children: React.ReactNode | React.ReactNode[] | JSX.Element | JSX.Element[];
}

// tslint:disable-next-line:variable-name
export const SelectPortal = ({ children }: SelectPortalProps) => {
  const portalRef = React.createRef<HTMLDivElement>();
  return <>
    <div
      id="select-portal"
      ref={portalRef}
      style={{
        zIndex: 9999,
        position: 'absolute',
        top: '0px',
      }}
      tabIndex={-1}
    />
    <SelectPortalContext.Provider value={portalRef}>
      {children}
    </SelectPortalContext.Provider>
  </>;
};

export const useSelectPortal = () => React.useContext(SelectPortalContext);
